export const FILTER_NOT_AVAILABLE_IN_CALENDAR_TEXT =
  'This filter is not applicable for the Calendar View';

export const DAY_GRID_WEEK = 'dayGridWeek';
export const DAY_GRID_MONTH = 'dayGridMonth';
export const EXTRA_HEIGHT = 254;
